
    <div *ngIf="is_no_data">
      <div class="col-12 mb-3 p-1" >
          <div class="card">
              <div class="card-body">
                  <a class="t" style="font-size: medium;color: black;">{{'COMMON.MESSAGES.SPORT-NO-EVENT' | translate}}</a>
              </div>
          </div>
      </div>
    </div>

    <app-race-details *ngIf="viewSelectionBlock" [selectedMeeting]="selectedMeeting"></app-race-details>
    
    <div [hidden]="viewSelectionBlock" class="container mt-2 pb-4 "  style="margin-bottom: 90px !important;">
      <div class="row" id="accordionExample">
    
          <div class="betting-category card-collapsible mb-2" id="dropdown" (click)="colorChange($event,i)" *ngFor="let odd of ODDs; let i=index;">
            <div class="card-header" id="scrollto{{i}}">
              <div (click)="getMeetingDataById(odd.id,odd.meetingLocalTime)" class="dropdown-toggle-chevron collapsed" data-toggle="collapse"  [attr.data-target]="'#id' + i" aria-expanded="true" aria-controls="collapseOne">
                <div class="race-header px-0 border-0">
                  <div class="race-icon bordered mr-2">
                    <span class="icon icon-black" [ngClass] = "[selectedBetCategory.sport == 'DG' ? 'icon-greyhound':'icon-horse']"></span>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="t">{{odd.meetingName}}</span>
                    <span class="t-faded t-smaller">{{odd.meetingLocalTime}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="id{{i}}" class="collapse accordion-body"  data-parent="#accordionExample">
            <div *ngIf="isOddShown(odd.id)">
      
              <div class="d-flex border-top pt-3 pb-3 sub-item" *ngFor="let sOdd of selectedEventODD;">
                <div class="d-flex flex-column">
                  <span class="t">{{sOdd.eventLabel}}</span>
                  <span class="t-faded t-smaller">{{sOdd.eventName}}</span>
                </div>
                <div class="extra d-flex">
                  <div class="d-flex flex-column align-items-end">
                    <span class="t">{{sOdd.eventTime}}</span>
                    <span class="t-faded t-smaller">{{sOdd.eventLocalDate}}</span>
                  </div>
      
                  <a (click)="viewRaceDetails(sOdd,$event)" class="btn btn-tertiary icon ml-2">
                    <span class="icon icon-arrow-right"></span>
                  </a>
      

                  <button [disabled]=" (!is_logged && sOdd.eventLabel.substr(sOdd.eventLabel.length-3,2) == 'AU') || sOdd.eventLabel.substr(sOdd.eventLabel.length-3,2) == 'VR'" (click) = "viewInfoDetails(sOdd)" 
                  class="btn btn-tertiary icon ml-2">
                  <span  class="icon icon-info" ></span>
                </button>

                </div>
              </div>
           
            </div>
          </div>
          </div>
      </div>
    </div>

    



